import apiMeterClient from './apiMeterClient'

const END_POINT = '/meters'

const get = (meter) => 
    apiMeterClient.get( `${END_POINT}/${meter.id}?key=${meter.key}` )

const control = (meter, status) => 
    apiMeterClient.post( `${END_POINT}/control/${meter}`, {
        fotocelda: status.fotocelda,
        control: status.control
    })

const dimmer = (meter, payload) => 
    apiMeterClient.post( `${END_POINT}/dimmer/${meter}`, {
        value: payload,
        // control: status.control
    })

const schedule = (meter, payload) => 
    apiMeterClient.post( `${END_POINT}/schedule/control/${meter}`, payload)

const suntime = (meter, payload) => 
    apiMeterClient.post( `${END_POINT}/schedule/solar/general/${meter}`, payload)

const infohw = (meter) => 
    apiMeterClient.get( `${END_POINT}/info/${meter}`)

const Meter = { get, control, schedule, suntime, dimmer, infohw }

export default Meter